import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import { REDUCER_CART_NOTIFIER_NAME } from 'moduleCartNotifier/constants';
import { reducerCartNotifier } from 'moduleCartNotifier/reducers';
import { State } from 'moduleBase/types/State';
import { ActionCreatorsMapObject, bindActionCreators } from 'redux';
import { StateType } from 'moduleCartNotifier/types/StateType';
import { cartNotifierLoad } from 'moduleCartNotifier/actions/load';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { CreateProjectModal } from 'moduleCartNotifier/components/CreateProjectModal';
import { CartNotifierLink } from 'moduleCartNotifier/components/CartNotifierLink';

type DispatchPropsType = {
  load: () => void;
}

type PropsType = StateType & DispatchPropsType & {};

const CartNotifier: FC<PropsType> = ({
  count,
  load,
}) => {
  const [isVisibleCreateProjectModal, setIsVisibleCreateProjectModal] = useState<boolean>(false);

  useEffect(() => {
    load();
  }, []);

  const createProjectModalShow = () => {
    setIsVisibleCreateProjectModal(true);
  };

  const createProjectModalHide = () => {
    setIsVisibleCreateProjectModal(false);
  };

  return (
    <>
      <CartNotifierLink count={count} createProjectModalShow={createProjectModalShow} />
      <CreateProjectModal
        isVisibleCreateProjectModal={isVisibleCreateProjectModal}
        createProjectModalHide={createProjectModalHide}
      />
    </>
  );
};

export default connect<StateType, DispatchPropsType>(CartNotifier, {
  reducers: { name: REDUCER_CART_NOTIFIER_NAME, reducer: reducerCartNotifier, isNeedUnregister: false },
  mapStateToProps: (state: State) => state[REDUCER_CART_NOTIFIER_NAME],
  mapDispatchToProps: (dispatch) => (bindActionCreators<ActionCreatorsMapObject, DispatchPropsType>({
    load: cartNotifierLoad,
  }, dispatch)),
});
